import { call, put, takeEvery } from 'redux-saga/effects';
import { mockSMEs } from '../../../../utils/mockData';
import * as actions from './_actions';
import * as types from './_actionTypes';

function* fetchSmeRequestsSaga() {
  try {
    const pendingSMEs = mockSMEs.filter(sme => sme.status === 'pending');
    yield put(actions.fetchSmeRequestsSuccess(pendingSMEs));
  } catch (error) {
    yield put(actions.fetchSmeRequestsFailure(error.message));
  }
}

function* fetchContentRequestsSaga() {
  try {
    const mockContentRequests = [
      {
        id: 1,
        title: 'Advanced Data Structures',
        type: 'video',
        smeId: 1,
        smeName: 'Dr. Rajesh Gupta',
        subject: 'Computer Science',
        status: 'pending',
        uploadedAt: '2024-01-15T10:00:00Z',
        description: 'Comprehensive video on advanced data structures including trees and graphs'
      },
      {
        id: 2,
        title: 'Calculus Quiz Set',
        type: 'quiz',
        smeId: 2,
        smeName: 'Prof. Meera Patel',
        subject: 'Mathematics',
        status: 'pending',
        uploadedAt: '2024-01-14T15:30:00Z',
        description: 'Interactive quiz covering differential and integral calculus'
      }
    ];
    
    yield put(actions.fetchContentRequestsSuccess(mockContentRequests));
  } catch (error) {
    yield put(actions.fetchContentRequestsFailure(error.message));
  }
}

function* approveSmeRequestSaga(action) {
  try {
    yield new Promise(resolve => setTimeout(resolve, 1000));
    yield put(actions.approveSmeSuccess(action.payload));
  } catch (error) {
    yield put(actions.approveSmeFailure(error.message));
  }
}

function* rejectSmeRequestSaga(action) {
  try {
    yield new Promise(resolve => setTimeout(resolve, 1000));
    yield put(actions.rejectSmeSuccess(action.payload));
  } catch (error) {
    yield put(actions.rejectSmeFailure(error.message));
  }
}

function* approveContentRequestSaga(action) {
  try {
    yield new Promise(resolve => setTimeout(resolve, 1000));
    yield put(actions.approveContentSuccess(action.payload));
  } catch (error) {
    yield put(actions.approveContentFailure(error.message));
  }
}

function* adminSmeApprovalSaga() {
  yield takeEvery(types.FETCH_SME_REQUESTS_REQUEST, fetchSmeRequestsSaga);
  yield takeEvery(types.FETCH_CONTENT_REQUESTS_REQUEST, fetchContentRequestsSaga);
  yield takeEvery(types.APPROVE_SME_REQUEST, approveSmeRequestSaga);
  yield takeEvery(types.REJECT_SME_REQUEST, rejectSmeRequestSaga);
  yield takeEvery(types.APPROVE_CONTENT_REQUEST, approveContentRequestSaga);
}

export default adminSmeApprovalSaga;